import { useState } from "react";
import { Box, Button, Card, CardContent, Stack, Typography, TextField, Divider } from "@mui/material";
import { bridgeStripeApi } from "./bridgeStripeApi";

export default function BridgeStripeSandbox() {
  const [busy, setBusy] = useState(false);
  const [out, setOut] = useState(null);
  const [err, setErr] = useState(null);

  // Transfer form state
  const [amount, setAmount] = useState(1);
  const [sourceAddress, setSourceAddress] = useState("AnwdkBwNJXYMG9BcbCJovMyLdKGbQE6kJTgTMpf6bEwZ");
  const [paymentRail, setPaymentRail] = useState("solana");
  const [sourceCurrency, setSourceCurrency] = useState("usdc");
  const [projectId, setProjectId] = useState("test id");

  async function run(fn) {
    setBusy(true);
    setErr(null);
    setOut(null);

    try {
      const json = await fn();
      setOut(json);
    } catch (e) {
      setErr({
        message: e.message,
        status: e.status,
        payload: e.payload
      });
    } finally {
      setBusy(false);
    }
  }

  return (
    <Box sx={{ maxWidth: 980, mx: "auto", p: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 800, mb: 2 }}>
        BridgeStripe Sandbox
      </Typography>

      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
            Customer
          </Typography>

          <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
            <Button disabled={busy} variant="outlined" onClick={() => run(() => bridgeStripeApi.getCustomer())}>
              Get customer
            </Button>
            <Button disabled={busy} variant="contained" onClick={() => run(() => bridgeStripeApi.createCustomer())}>
              Create customer
            </Button>
            <Button disabled={busy} color="error" variant="outlined" onClick={() => run(() => bridgeStripeApi.deleteCustomer())}>
              Delete customer
            </Button>
            <Button disabled={busy} variant="outlined" onClick={() => run(() => bridgeStripeApi.getKyc())}>
              Get KYC
            </Button>
          </Stack>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
            Transfer
          </Typography>

          <Stack spacing={1.5} sx={{ maxWidth: 720 }}>
            <TextField
              label="Amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
              inputProps={{ min: 0 }}
              size="small"
            />
            <TextField
              label="Source address"
              value={sourceAddress}
              onChange={(e) => setSourceAddress(e.target.value)}
              size="small"
            />
            <Stack direction="row" spacing={1}>
              <TextField
                label="Payment rail"
                value={paymentRail}
                onChange={(e) => setPaymentRail(e.target.value)}
                size="small"
                sx={{ flex: 1 }}
              />
              <TextField
                label="Source currency"
                value={sourceCurrency}
                onChange={(e) => setSourceCurrency(e.target.value)}
                size="small"
                sx={{ flex: 1 }}
              />
            </Stack>
            <TextField
              label="Metadata.projectId"
              value={projectId}
              onChange={(e) => setProjectId(e.target.value)}
              size="small"
            />

            <Stack direction="row" spacing={1}>
              <Button
                disabled={busy}
                variant="contained"
                onClick={() =>
                  run(() =>
                    bridgeStripeApi.createTransfer({
                      legalId: (typeof window !== 'undefined' ? (window.localStorage.getItem('agent-legal-id') || '').trim() : ''),
                      amount,
                      sourceAddress,
                      paymentRail,
                      sourceCurrency,
                      metadata: { projectId }
                    })
                  )
                }
              >
                Create transfer
              </Button>

              <Button
                disabled={busy}
                variant="outlined"
                onClick={() => run(() => bridgeStripeApi.getTransfer((typeof window !== 'undefined' ? (window.localStorage.getItem('agent-legal-id') || '').trim() : '')))}
              >
                Get current transfer
              </Button>
            </Stack>
          </Stack>

          {(err || out) && (
            <>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                Result
              </Typography>

              {err ? (
                <Box sx={{ bgcolor: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.25)", borderRadius: 2, p: 2 }}>
                  <Typography sx={{ fontWeight: 700 }}>Error</Typography>
                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                    {err.message} {err.status ? `(HTTP ${err.status})` : ""}
                  </Typography>
                  <pre style={{ marginTop: 12, whiteSpace: "pre-wrap" }}>
                    {JSON.stringify(err.payload, null, 2)}
                  </pre>
                </Box>
              ) : (
                <Box sx={{ bgcolor: "#0B1220", color: "#E5E7EB", borderRadius: 2, p: 2 }}>
                  <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                    {JSON.stringify(out, null, 2)}
                  </pre>
                </Box>
              )}
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
